<template>
<svg :class="status" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="6" height="6" rx="3" transform="matrix(1 0 0 -1 0.195312 6.68359)" fill="#0ACF97"/>
</svg>

</template>

<script>
export default {
    props: {
        status: {
            type: String,
            default: String
        }
    }
}
</script>

<style lang="scss" scoped>
svg {
    &.red {
        rect {
            fill: #FA5C7C;
        }
    }
    &.yellow {
        rect {
            fill: #FFBC00;
        }
    }
    &.green {
        rect {
            fill: #0ACF97;
        }
    }
}
</style>